module.exports = __webpack_public_path__ + "img/philosophy_skin.d48da09c.jpg";